import Head from 'next/head';
import styled from 'styled-components';

const Wrap = styled.div`
  .body-bd-main {
    padding: 50px 100px;
  }
  .body-bd-main h2 {
    font-size: 24px;
    margin: 0 0 30px;
  }
  .body-bd-main p {
    font-size: 14px;
    line-height: 28px;
  }
  .body-bd-main .com-intro {
  }
  .body-bd-main .com-intro p {
    margin: 0 0 30px;
    text-align: justify;
  }
  .body-bd-main .com-contacts {
    margin: 0 0 30px;
  }
  .body-bd-main .com-contacts p {
    margin: 0 0 10px;
  }
  .body-bd-main img {
    width: 150px;
    height: 150px;
  }
  .body-bd-main p a:hover {
    text-decoration: underline;
  }
`;

const Index = () => {
  return (
    <Wrap className="container">
      <Head>
        <title>关于我们_么么直播_美女视频直播秀场</title>
      </Head>
      <div className="body">
        <div className="body-hd">关于我们</div>
        <div className="body-bd fix">
          <div className="body-bd-main">
            <h2>平台简介</h2>
            <div className="com-intro">
              <p>
                「么么直播」是一个与真人美女主播在线视频聊天的交友社区，于2014年7月1日正式上线。支持百万人同时在线视频聊天交友、互动。上千位多才多艺的美女主播和数十万重情重义的帅哥玩家一起在么么直播快乐的玩耍。么么直播致力于为天涯海角的网友提供一个情感交流的平台，在这里，我们追求平等、分享快乐、相互认同、共同进步。
              </p>
              <p>
                作为最早布局“云+端”模式的秀场网站，么么直播在业内率先启动「多屏互动」的无线战略，实施全平台的登陆布局，全面覆盖WEB端、Android端、iOS端，满足用户多屏观看的需求。同时针对不同平台的特性，针对性地优化操作体验，在同类产品中用户口碑名列前茅。
              </p>
              <p>
                未来，么么直播还将在多元化的内容储备、个性化的产品体验、定制化营销服务领域继续发力，引领音视频社交行业的体验革命。
              </p>
            </div>
            <h2>联系我们</h2>
            <div className="com-contacts">
              <p>邮箱 ： kefu@2339.com</p>
            </div>
          </div>
        </div>
      </div>
    </Wrap>
  );
};

export default Index;
